import { motion } from "framer-motion";
import { FC } from "react";
import { Link } from "react-router-dom";

//!ANTD

//!ROUTES
import * as appRoutes from "config/routes.config";

//!IMAGES
import organisation from "../../../../../assets/images/app/iam_organism.svg";
import parent from "../../../../../assets/images/app/iam_parent.svg";
import student from "../../../../../assets/images/app/iam_student.svg";
import prof from "../../../../../assets/images/app/iam_teacher.svg";

//!STYLES
import s from "./assets/typeProfile.module.css";

type typeLogin = {
  isLogin: boolean;
};

const TypeProfile: FC<typeLogin> = ({ isLogin }) => {
  return (
    <div className={s.choiceBox}>
      <div className={s.choiceBoxTitle}>Choisis ta catégorie</div>
      <span>Élève, professeur, parent, ou organisme<br />et personnalise ton expérience !</span>
      <div className={s.choice__profile}>
        <Link
          to={
            isLogin
              ? `${appRoutes.LOGIN}/teacher`
              : appRoutes.REGISTER_TEACHER_BY_EMAIL
          }
          style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center" }}
        >
          <motion.div
            className={s.prof}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.8 }}
          >
            <img
              height={"100%"}
              width={"100%"}
              src={prof}
              alt="prof maa"
            />
          </motion.div>

          <Link
            to={
              isLogin
                ? `${appRoutes.LOGIN}/teacher`
                : appRoutes.REGISTER_TEACHER_BY_EMAIL
            }
            style={{ marginTop: "1em" }}
          >
            Je suis prof
          </Link>
        </Link>

        <Link
          to={
            isLogin ? `${appRoutes.LOGIN}/student` : appRoutes.REGISTER_STUDENT
          }
          style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center" }}
        >
          <motion.div
            className={s.prof}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.8 }}
          >
            <img
              height={"100%"}
              width={"100%"}
              src={student}
              alt="student maa"
            />
          </motion.div>
          <Link
            style={{ marginTop: "1em" }}
            to={
              isLogin
                ? `${appRoutes.LOGIN}/student`
                : appRoutes.REGISTER_STUDENT
            }
          >
            Je suis étudiant
          </Link>
        </Link>

        <Link
          to={
            isLogin ? `${appRoutes.LOGIN_PARENT}` : appRoutes.REGISTER_PARENT
          }
          style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center" }}
        >
          <motion.div
            className={s.prof}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.8 }}
          >
            <img
              height={"100%"}
              width={"100%"}
              src={parent}
              alt="parent maa"
            />
          </motion.div>
          <Link
            style={{ marginTop: "1em" }}
            to={
              isLogin
                ? `${appRoutes.LOGIN_PARENT}`
                : appRoutes.REGISTER_PARENT
            }
          >
            Je suis parent
          </Link>
        </Link>

        <Link
          to={
            isLogin ? `${appRoutes.LOGIN_ORGANISM}` : appRoutes.REGISTER_ORGANISM
          }
          style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center" }}
        >
          <motion.div
            className={s.prof}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.8 }}
          >
            <img
              height={"100%"}
              width={"100%"}
              src={organisation}
              alt="parent maa"
            />
          </motion.div>
          <Link
            style={{ marginTop: "1em" }}
            to={
              isLogin
                ? `${appRoutes.LOGIN_ORGANISM}`
                : appRoutes.REGISTER_ORGANISM
            }
          >
            Je suis un organisme
          </Link>
        </Link>
      </div>
    </div>
  );
};

export default TypeProfile;
